import React from 'react';


const PerformanceReportStatus = ({ statusinfo }) => { 
     
return (<div class="bg-white dark:bg-gray-900">
  <div class="mx-auto max-w-8xl mb-5">
    <div class="border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden">
      <div class="grid grid-cols-1 gap-px bg-gray-900/5 sm:grid-cols-2 lg:grid-cols-6 dark:bg-white/10">
        <div class="bg-white px-4 py-6 sm:px-6 lg:px-8 dark:bg-gray-900">
          <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Products in test</p>
          <p class="mt-2 flex items-baseline gap-x-2">
            <span class="text-4xl font-semibold tracking-tight text-gray-900 dark:text-white">{statusinfo.product_counts}</span>
          </p>
        </div>
        <div class="bg-white px-4 py-6 sm:px-6 lg:px-8 dark:bg-gray-900">
          <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Products complete</p>
          <p class="mt-2 flex items-baseline gap-x-2">
            <span class="text-4xl font-semibold tracking-tight text-gray-900 dark:text-white">{statusinfo.progress}</span>
            <span class="text-sm text-gray-500 dark:text-gray-400"></span>
          </p>
        </div>
        <div class="bg-white px-4 py-6 sm:px-6 lg:px-8 dark:bg-gray-900">
          <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Days running</p>
          <p class="mt-2 flex items-baseline gap-x-2">
            <span class="text-4xl font-semibold tracking-tight text-gray-900 dark:text-white">{statusinfo.processed_days}</span>
          </p>
        </div>
        <div class="bg-white px-4 py-6 sm:px-6 lg:px-8 dark:bg-gray-900">
          <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Average uplift</p>
          <p class="mt-2 flex items-baseline gap-x-2">
            <span class="text-4xl font-semibold tracking-tight text-gray-900 dark:text-white">{statusinfo.uplift}%</span>
          </p>
        </div>
         <div class="bg-white px-4 py-6 sm:px-6 lg:px-8 dark:bg-gray-900">
          <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Tokens used</p>
          <p class="mt-2 flex items-baseline gap-x-2">
            <span class="text-4xl font-semibold tracking-tight text-gray-900 dark:text-white">{statusinfo.token_used}</span>
          </p>
        </div>
        <div class="bg-white px-4 py-6 sm:px-6 lg:px-8 dark:bg-gray-900">
          <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Best strategy</p>
          <p class="mt-2 flex items-baseline gap-x-2">
            <span class="text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">{statusinfo.prefered_permutation}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>)}

export default PerformanceReportStatus;